(function () {
  // Prevent duplicate initialization
  if (window.__appstleBwpObserver__) return;

  function setBwpVisibility() {
    // Target the wrapper container directly
    const bwpContainer = document.querySelector('.bwp-buy-now-toggle-container');
    if (!bwpContainer) return;

    // Check if a subscription plan is selected (value must be non-empty for actual subscription)
    const selectedPlan = document.querySelector('.appstle_sub_widget input[name=selling_plan]:checked');
    // One-time purchase has empty value, subscription has a selling plan ID
    const isSubscription = selectedPlan !== null && selectedPlan.value !== '';

    // Hide/show the Buy with Prime container
    bwpContainer.style.display = isSubscription ? 'none' : '';
  }

  // Primary method: Listen to Appstle custom events
  document.addEventListener('AppstleSubscription:SubscriptionWidget:SellingPlanSelected', function() {
    setBwpVisibility();
  });

  document.addEventListener('AppstleSubscription:SubscriptionWidget:SellingPlanDeSelected', function() {
    setBwpVisibility();
  });

  // Fallback: MutationObserver to watch for subscription radio button changes
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'checked') {
        setBwpVisibility();
        break;
      }
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    // Initial state check
    setBwpVisibility();

    // Watch for changes to Appstle widget radio buttons
    const appstleWidget = document.querySelector('#appstle_subscription_widget0');
    if (appstleWidget) {
      observer.observe(appstleWidget, {
        subtree: true,
        attributes: true,
        attributeFilter: ['checked'],
      });
    }
  });

  window.__appstleBwpObserver__ = observer;
})();
